<template>
  <v-alert
    v-model="alertData"
    class="alert mb-1"
    dismissible
    :icon="icon"
    :type="type"
    dense
    text
  >
    {{
      msg ||
        "Desculpe, ocorreu um erro no processamento da sua solicitação. Por favor, tente novamente em alguns instantes."
    }}
  </v-alert>
</template>

<script>
export default {
  name: 'AppAlertView',
  props: { alert: Boolean, msg: String, type: String, icon: String },
  computed: {
    alertData: {
      get() {
        return this.alert;
      },
      set(value) {
        this.$emit('updateAlert', value);
      },
    },
  },
};
</script>
<style>
.alert {
  font-size: 15px;
}
</style>
